// extracted by mini-css-extract-plugin
module.exports = {"component":"private_component_1_ybl","message":"private_message_1oMA_"};